// Modelos oferecidos no builder de PowerAgents.
//
// Este arquivo já foi um catálogo escrito à mão, e envelheceu sozinho: ficou com cinco
// modelos que ninguém escolheu, com preços digitados que a OpenRouter já tinha mudado, e
// sem o modelo que o runtime de fato usava. Agora ele guarda só a CURADORIA (quais modelos
// e em que tier) como FALLBACK — os números vivos vêm de
// GET /api/v1/accounts/:id/power_agents/models, que consulta a OpenRouter e cacheia 6h.
//
// Se aquele endpoint falhar, a tela abre com esta lista e SEM os números, em vez de
// apresentar dado velho como se fosse medido.
//
// - `tier`:   1 = a faixa mais barata; 2 = a mais capaz (ver `TIERS`).
// - `vision`: interpreta imagem recebida. Hoje os quatro leem imagem, então o flag não
//   porteia nada — quem decide o que sobe ao modelo é o runtime, pela lista de tipos que
//   ele sabe montar. Fica como informação de catálogo.
// - `tools`:  suporta function-calling (obrigatório para as tools do agente).
export const POWER_AGENT_MODELS = [
  {
    id: 'openai/gpt-6-luna',
    label: 'GPT-6 Luna',
    tier: 1,
    vision: true,
    tools: true,
  },
  {
    id: 'anthropic/claude-haiku-5.5',
    label: 'Claude Haiku 5.5',
    tier: 1,
    vision: true,
    tools: true,
  },
  {
    id: 'google/gemini-3.8-flash',
    label: 'Gemini 3.8 Flash',
    tier: 2,
    vision: true,
    tools: true,
  },
  {
    id: 'x-ai/grok-4.7',
    label: 'Grok 4.7',
    tier: 2,
    vision: true,
    tools: true,
  },
];

// Os dois tiers oferecidos. A pessoa escolhe UM; o fallback vem junto, porque é consequência
// da escolha e não uma segunda pergunta. O que cada um é para o cliente está no i18n
// (`MODELS.TIER_n_HINT`), e não aqui, para não haver duas descrições divergindo.
export const TIERS = [
  {
    tier: 1,
    primary: 'openai/gpt-6-luna',
    fallback: 'anthropic/claude-haiku-5.5',
  },
  {
    tier: 2,
    primary: 'google/gemini-3.8-flash',
    fallback: 'x-ai/grok-4.7',
  },
];

// O par inicial de um agente novo é o da faixa 1, inteiro. Era o principal da faixa 1 com o
// principal da faixa 2 de reserva: um par que não é de faixa nenhuma, contra a decisão do
// Murilo de 22/09 (a reserva da faixa 1 é a mesma para todos).
export const DEFAULT_MODEL_PRIMARY = TIERS[0].primary;
export const DEFAULT_MODEL_FALLBACK = TIERS[0].fallback;

export const findModel = id => POWER_AGENT_MODELS.find(m => m.id === id);

// O catálogo vivo da OpenRouter nomeia "Provedor: Modelo" ("Anthropic: Claude Haiku 5.5"). Na
// tela o provedor só ocupa espaço (e cortava o nome no cartão); o id completo continua no título.
export const rotuloCurto = rotulo => (rotulo || '').replace(/^[^:]+:\s*/, '');
